import apiClient from '@src/api/clients';

const PLAN_URL = 'app1/facebook/local-plan/';
const BUILD_URL = 'app1/facebook/local-build/';
const IMPORTS_URL = 'app1/local-ad-imports/';

/**
 * What a build would create. Pure on the server — writes nothing — so this is
 * safe to call on every change of the floor.
 */
export const fetchLocalPlan = (payload) =>
  apiClient.request({
    url: PLAN_URL,
    method: 'GET',
    payload,
  });

/**
 * Create the campaigns and ad sets. Everything lands PAUSED.
 * Pass dry_run: false for the live write — it defaults to a dry run.
 */
export const buildLocalCampaigns = (payload) =>
  apiClient.request({
    url: BUILD_URL,
    method: 'POST',
    payload,
  });

/** Batches of ads pushed in by the generator app. */
export const fetchLocalAdBatches = () =>
  apiClient.request({
    url: IMPORTS_URL,
    method: 'GET',
  });

/** Publish one batch's ads to Facebook. Defaults to a dry run. */
export const publishLocalAdBatch = (batchId, payload) =>
  apiClient.request({
    url: `${IMPORTS_URL}${batchId}/publish/`,
    method: 'POST',
    payload,
  });
